import React, { Component } from "react";
import "./progress-bar.scss";

class ProgressBar extends Component {
  state = { progress: 0 };
  componentDidMount() {
    let interval = 300;
    if (this.props.interval) {
      interval = this.props.interval / 20;
    }
    setInterval(() => {
      const { progress } = this.state;
      if (progress < 100) {
        this.setState({ progress: progress + 5 });
      }
    }, interval);
  }
  render() {
    const { progress } = this.state;

    return (
      <div className="progressWRapper">
        <div className="progress" style={{ width: `${progress}%` }}></div>
      </div>
    );
  }
}

export default ProgressBar;
